import '../../../styles/blocks/_roadmap-navigation.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import modalCancelActions from 'actions/modalCancelActions';
import { formatText } from 'core/i18n';
import { ButtonContinue } from './ButtonContinue/ButtonContinue';
import { ButtonFinalize } from './ButtonFinalize/ButtonFinalize';
import { ButtonCancel } from './ButtonCancel/ButtonCancel';
import { ButtonPrev } from './ButtonPrev/ButtonPrev';
import { ButtonPrevSpecial } from './ButtonPrevSpecial/ButtonPrevSpecial';

const RoadmapNavigationComponent = ({
    immStepsState,
    modalCancelActions,
    stepsActions,
    buttonCancelAction,
    buttonCancelHidden = false,
    buttonCancelText = formatText('button-exit'),
    buttonContinueAction = null,
    buttonContinueClass = 'form__button form__button-primary roadmap-navigation__button-continue',
    buttonContinueDisabled = false,
    buttonContinueFakeDisabled,
    buttonContinueLoading = false,
    buttonContinueText = formatText('button-continue'),
    buttonContinueType = 'button',
    buttonFinalizeAndContinueHidden = false,
    buttonFinalizeDisabled = false,
    buttonFinalizeFakeDisabled,
    buttonFinalizeHidden = true,
    buttonFinalizeText = formatText('button-finalize'),
    buttonPrevAction = null,
    buttonPrevHidden = false,
    buttonPrevSpecialHidden = true,
    buttonPrevText = formatText('button-prev'),
    isButtonContinueLoading = false,
    stepFooter = false,
    style = {},
}) => {
    return (
        <div style={style} className={`form__buttons roadmap-navigation ${stepFooter && 'step-footer'}`}>
            <ButtonCancel
                buttonCancelAction={buttonCancelAction}
                buttonCancelHidden={buttonCancelHidden}
                buttonCancelText={buttonCancelText}
                showModalCancel={modalCancelActions.showModalCancel}
            />
            <ButtonPrev
                buttonPrevAction={buttonPrevAction}
                buttonPrevHidden={buttonPrevHidden}
                buttonPrevText={buttonPrevText}
                changeCurrentStep={stepsActions.changeCurrentStep}
                currentStep={immStepsState.get('currentStep')}
            />
            <ButtonPrevSpecial buttonPrevAction={buttonPrevAction} buttonPrevSpecialHidden={buttonPrevSpecialHidden} />
            <ButtonContinue
                buttonContinueAction={buttonContinueAction}
                buttonContinueClass={buttonContinueClass}
                buttonContinueDisabled={buttonContinueDisabled}
                buttonContinueFakeDisabled={buttonContinueFakeDisabled}
                buttonContinueLoading={buttonContinueLoading}
                buttonContinueText={buttonContinueText}
                buttonContinueType={buttonContinueType}
                buttonFinalizeAndContinueHidden={buttonFinalizeAndContinueHidden}
                buttonFinalizeHidden={buttonFinalizeHidden}
                isButtonContinueLoading={isButtonContinueLoading}
            />
            <ButtonFinalize
                buttonContinueAction={buttonContinueAction}
                buttonContinueType={buttonContinueType}
                buttonFinalizeAndContinueHidden={buttonFinalizeAndContinueHidden}
                buttonFinalizeDisabled={buttonFinalizeDisabled}
                buttonFinalizeFakeDisabled={buttonFinalizeFakeDisabled}
                buttonFinalizeHidden={buttonFinalizeHidden}
                buttonFinalizeText={buttonFinalizeText}
            />
        </div>
    );
};

const mapStateToProps = state => ({
    modalCancel: state.modalCancel,
    immStepsState: state.steps,
});
const mapDispatchToProps = dispatch => ({
    modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    stepsActions: bindActionCreators(stepsActions, dispatch),
});

export const RoadmapNavigation = connect(mapStateToProps, mapDispatchToProps)(RoadmapNavigationComponent);
